import { styled } from "@mui/material/styles";
import React from "react";
import AuditCompsTitle from "./AuditCompsTitle";
import AuditFiltersContainer from "./AuditFiltersContainer";
import AuditorListResults from "./AuditorListResults";
import AuditSearchHeaders from "./AuditSearchHeaders";
import AuditSearchResultsContainer from "./AuditSearchResultsContainer";
import AuditTabs from "./AuditTabs";
import { SCOPES, audit_tabs } from "./constants";
import PermissionsGate from "./permissions/PermissionsGate";

const StyledAuditSearchFlexboxContainer = styled("div")(() => ({
    alignItems: "center",
    flex: "1 1 auto",
}));

const AuditSearch = (props) => {
    const { activeTab, handleSort, searchResponse } = props;

    const { auditorSearch, auditorList } = audit_tabs;
    return (
        <React.Fragment>
            <PermissionsGate scopes={[SCOPES.canViewFilters]} hide>
                <AuditFiltersContainer />
            </PermissionsGate>
            <AuditCompsTitle searchResponse={searchResponse} />
            <StyledAuditSearchFlexboxContainer>
                <div className="simPaper" style={{ display: "flex", flexDirection: "column", flex: "1 1 auto" }}>
                    <AuditTabs />
                    <AuditSearchHeaders activeHeader={activeTab} handleSort={handleSort} />
                    {activeTab === auditorSearch && <AuditSearchResultsContainer />}
                    {activeTab === auditorList && <AuditorListResults {...props} />}
                </div>
            </StyledAuditSearchFlexboxContainer>
        </React.Fragment>
    );
};

export default AuditSearch;
